import "./App.css";
import PrivateRoute from "./common/PrivateRoute";
import Details from "./page/details";
import Home from "./page/home";
import Search from "./page/search";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getOS from "./utils/getOS.util";
import useFontSize from "./hooks/useFontSize";
import useDarkMode from "./hooks/useDarkMode";
import colors from "./tailwindcss/colors.tailwind";
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
import AdminHome from "./page/admin/home/adminHome";
import AddMachine from "./page/admin/add/addMachine";
import Pricing from "./page/admin/pricing/pricing";
import AdminLayouts from "./components/admin/layouts/adminLayouts";
import Wrapper from "./components/admin/layouts/Wrapper/Wrapper";
import AdminRouter from "./components/router/ContentRouter";
import AdminPrivateRoute from "./common/AdminPrivateRoute";
import AddAndEditMachineRouter from "./components/router/AddAndEditMachine";
import { appPages } from "./context/pages.config";
import AdminLocationRouter from "./components/router/LocationRouter";
import CompanyRouter from "./components/router/CompanyRouter";
import UserContactsRouter from "./components/router/UserContactsRouter";
import AddAndEditUserContact from "./components/router/AddAndEditUserContact";
import AddLocation from "./page/admin/locationInfo/addLocation";
import UnderConstructionPage from "./page/underConstruction/UnderConstruction";
import AdminWatchListRouter from "./components/router/WatchListRouter";
import WatchList from "./page/watchList/WatchList";
// import { DummyAPICall } from "./services/companyService"; // No longer needed — token handling is done via the dedicated refresh token API
import { useEffect } from "react";
import { LoadingProvider, useLoading } from "./context/loadingContext";
import { AuthProvider } from "./context/authContext";
import { AuthModalProvider } from "./context/authModalContext";
import ResetPassword from "./page/auth/ResetPassword";

function AppRoutes() {
  const { globalLoading } = useLoading();

  useEffect(() => {
    if (globalLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [globalLoading]);

  // validateSession via DummyAPICall removed — token expiry is now handled automatically
  // by the refresh token flow in getApi.js / postApi.js / putApi.js / authService.js

  return (
    <>
      {globalLoading ? (
        <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50">
          <span className="loader"></span>
        </div>
      ) : null}
      <Routes>
        {/* Public auth routes */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Public routes */}
        <Route path="/" element={<div className="bg-[#fff]"><Home /></div>} />
        <Route path="/search" element={<div className="bg-[#fff]"><Search /></div>} />
        <Route path="/detail/:category/:id" element={<div className="bg-[#fff]"><Details /></div>} />
        <Route path="/detail" element={<div className="bg-[#fff]"><Details /></div>} />

        {/* Protected routes */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <div className="bg-[#fff]"><AdminHome /></div>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/add-list"
          element={<div className="bg-[#fff]"><AddMachine /></div>}
        />
        <Route
          path="/admin/pricing"
          element={
            <AdminPrivateRoute>
              <div className="bg-[#fff]"><Pricing /></div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/watch-list"
          element={
            <AdminPrivateRoute>
              <div className="bg-[#fff]"><WatchList /></div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.salesDashboardPage.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><CompanyRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.user.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><UserContactsRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.locations.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AdminLocationRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.equipments.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AdminRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.myAccount.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><UnderConstructionPage /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.watchList.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AdminWatchListRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path={appPages.salesAppPages.subPages.adminTools.to}
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><UnderConstructionPage /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/add-machine"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddAndEditMachineRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/edit-machine/:id"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddAndEditMachineRouter /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/edit-user-contact/"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddAndEditUserContact /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/edit-user-contact/:id"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddAndEditUserContact /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/edit-location/"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddLocation /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/edit-location/:id"
          element={
            <AdminPrivateRoute>
              <div data-component-name="App" className="flex grow flex-col">
                <AdminLayouts />
                <Wrapper><AddLocation /></Wrapper>
              </div>
            </AdminPrivateRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  getOS();
  const { isDarkTheme } = useDarkMode();
  const { fontSize } = useFontSize();
  dayjs.extend(localizedFormat);

  return (
    <>
      <style>{`:root {font-size: ${fontSize}px;
      --toastify-toast-bd-radius: 0.75rem;
      --toastify-color-dark:  ${colors.zinc["800"]};
      --toastify-color-info: ${colors.blue["500"]};
      --toastify-color-success: ${colors.emerald["500"]};
      --toastify-color-warning: ${colors.amber["500"]};
      --toastify-color-error: ${colors.red["500"]};
      --toastify-color-progress-light: linear-gradient(
        to right,
        ${colors.blue["500"]},
        ${colors.emerald["500"]},
        ${colors.amber["500"]},
        ${colors.red["500"]});`}</style>

      <LoadingProvider>
        <ToastContainer theme={isDarkTheme ? "dark" : "light"} hideProgressBar />
        <Router>
          <AuthProvider>
            <AuthModalProvider>
              <AppRoutes />
            </AuthModalProvider>
          </AuthProvider>
        </Router>
      </LoadingProvider>
    </>
  );
}

export default App;
